module.exports = __webpack_public_path__ + "static/media/clapAnim.de535bb5.svg";